<script setup lang='ts'>
import { APP_ROUTER, imageTransform } from '@qctsw/common'
import { timeFrom } from '@qctsw/utils'
import { logicRankNewsAuthor } from '@/logic/rank/newsAuthor'

const props = withDefaults(defineProps<{
  authorId?: number
  authorName?: string
  authorHeadImg?: string
}>(), {
  authorId: 0,
  authorName: '',
  authorHeadImg: '',
})

const {
  state,
  data,
  authorData,
  getRankData,
  getAuthorDetail,
} = logicRankNewsAuthor()

if (props.authorId)
  await Promise.all([getRankData(props.authorId), getAuthorDetail(props.authorId)])
</script>

<template>
  <div v-if="props.authorId" class="bg-white rounded">
    <UtilLoadState :state="state" :reload-handler="() => getRankData(props.authorId)">
      <div class="flex pt-sm px-sm">
        <div>
          <NAvatar v-if="props.authorHeadImg" round :size="50" :src="imageTransform(props.authorHeadImg, { width: 100, height: 100 })" />
          <div v-else class="flex items-center justify-center w-12.5 h-12.5 rounded-full bg-blue-5 text-white text-5 font-bold">
            {{ props.authorName ? props.authorName?.slice(0, 1) : '无' }}
          </div>
        </div>
        <div class="flex flex-col  ml-sm">
          <h5 class="text-4.5 font-bold text-title">
            {{ props.authorName || '暂无笔名' }}
          </h5>
          <p v-if="authorData" class="text-3 text-slate-5">
            作品：{{ authorData.articleCount ?? 0 }}
          </p>
        </div>
      </div>
      <div class="border-b-1 border-slate-2 my-2" />
      <div class="pb-sm px-sm">
        <h4 class="font-bold text-4.5">
          TA的作品
        </h4>
        <div v-for="(v, i) in data" :key="i" class="py-3 border-b-1 border-slate-2">
          <div class="flex">
            <NuxtLink class="h-20 aspect-16/9 block rounded-md overflow-hidden flex-shrink-0" :to="APP_ROUTER.newsDetail(v.id)">
              <img class="w-full h-full object-cover" :src="imageTransform(v.coverImgUrl)" alt="v.title">
            </NuxtLink>
            <div class="flex flex-col justify-between ml-2">
              <NuxtLink :to="APP_ROUTER.newsDetail(v.id)" class="line-clamp-2 hover:text-orange-6">
                {{ v.title }}
              </NuxtLink>
              <UtilContentTips :tips-data="{ date: (v.createTime) }" />
            </div>
          </div>
        </div>
        <div class="flex items-center justify-center mt-sm">
          <NuxtLink :to="APP_ROUTER.authorDetail(props.authorId)" class="bg-slate-2  rounded-full text-slate-6 text-center text-3 px-sm pt-2 pb-1.5">
            <span>查看更多</span>
            <i class="i-material-symbols:keyboard-double-arrow-right vertical-icon" />
          </NuxtLink>
        </div>
      </div>
    </UtilLoadState>
  </div>
</template>

<style lang='scss' scoped>
</style>
